import React from 'react';

export function NoDataAvailableTemplate({
  icon,
  title,
  subTitle,
  isError = false,
}: {
  icon: string;
  title: string;
  subTitle?: string;
  isError?: boolean;
}) {
  return (
    <div className="p-3" style={{ height: 'calc(100% - 4rem)' }}>
      <div className="flex justify-content-center align-items-center h-full">
        <div className="text-center">
          <i
            className={`${icon} ${isError ? 'text-red-500' : 'text-gray-500'} text-2xl mb-2 block`}
          ></i>
          <p className={`${isError ? 'text-red-500' : 'text-gray-500'}`}>
            {title}
          </p>
          <p className="text-sm text-gray-500 mt-1">{subTitle}</p>
        </div>
      </div>
    </div>
  );
}
